var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _g2, _g3, _g4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle, _path20, _path21, _path22, _path23, _circle2, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadisjsjsjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 693.97296,
    height: 712.57302,
    viewBox: "0 0 693.97296 712.57302",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a7e0d23c-0c47-41f1-93b9-87dfccd4c0f5-637",
    "data-name": "Path 968",
    d: "M752.75753,262.60547h-3.9v-106.977a61.915,61.915,0,0,0-61.915-61.915h-226.65a61.915,61.915,0,0,0-61.916,61.914v586.884a61.915,61.915,0,0,0,61.915,61.915h226.648a61.915,61.915,0,0,0,61.915-61.915v-403.758h3.9Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a1ad11fc-8226-4675-bbe0-e36020d9de96-638",
    "data-name": "Path 969",
    d: "M736.15756,151.48149v595.175a46.959,46.959,0,0,1-46.942,46.952h-231.3a46.966,46.966,0,0,1-46.973-46.952v-595.175a46.965,46.965,0,0,1,46.971-46.951h28.058a22.329,22.329,0,0,0,20.656,30.74h131.868a22.329,22.329,0,0,0,20.656-30.74h30.055a46.959,46.959,0,0,1,46.951,46.942Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "a71e44ec-7616-4081-86af-b6db32cd39f3-639",
    "data-name": "Path 39",
    d: "M678.82353,494.30947h-205.537a3.81,3.81,0,0,1-3.806-3.806V439.51949a3.811,3.811,0,0,1,3.806-3.806h205.537a3.811,3.811,0,0,1,3.806,3.806v50.985a3.811,3.811,0,0,1-3.806,3.806Zm-205.537-57.074a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284h205.537a2.286,2.286,0,0,0,2.284-2.284v-50.985a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "a3f57aef-fb20-4553-8f82-b751eb5ec42c-640",
    "data-name": "Path 40",
    d: "M536.85153,454.07448a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00221-.11712-.0019h-125.692Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "a617e1da-1a45-4bf0-a146-8b20186fa5b6-641",
    "data-name": "Path 41",
    d: "M536.85153,470.05846a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00219-.11712-.00189h-125.692Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "f83fafa3-5270-49ac-8952-eedc3d6c92ed-642",
    "data-name": "Path 42",
    d: "M678.82353,579.28947h-205.537a3.81,3.81,0,0,1-3.806-3.806V524.49949a3.811,3.811,0,0,1,3.806-3.806h205.537a3.811,3.811,0,0,1,3.806,3.806v50.985A3.811,3.811,0,0,1,678.82353,579.28947Zm-205.537-57.074a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284h205.537a2.286,2.286,0,0,0,2.284-2.284v-50.985a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "b1e095e5-1d51-47f4-b1e9-85a21efab4ec-643",
    "data-name": "Path 43",
    d: "M536.85153,539.33047a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.087-5.328h-125.692Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "e7ccabbb-2f45-40c9-adc9-a92013dc0f4d-644",
    "data-name": "Path 44",
    d: "M536.85153,555.3185a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.087-5.328h-125.692Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "ec532991-8ec8-4eba-a86f-87c70c278f41-645",
    "data-name": "Path 39-2",
    d: "M678.82353,664.54748h-205.537a3.81,3.81,0,0,1-3.806-3.806V609.7575a3.811,3.811,0,0,1,3.806-3.806h205.537a3.811,3.811,0,0,1,3.806,3.806v50.985a3.811,3.811,0,0,1-3.806,3.806Zm-205.537-57.074a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284h205.537a2.286,2.286,0,0,0,2.284-2.284v-50.985a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "a788f10e-f95b-4590-bad9-be702445c232-646",
    "data-name": "Path 40-2",
    d: "M536.85153,624.59148a2.66449,2.66449,0,1,0,0,5.329h125.605a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00219-.11712-.00189h-125.692Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "f15a5014-9b42-4c0b-a546-80766b911601-647",
    "data-name": "Path 41-2",
    d: "M536.85153,640.57846a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.0022-.11712-.00189h-125.692Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "b97f850c-7352-4ff9-8496-0f681ff3b244-648",
    "data-name": "Path 970",
    d: "M945.17252,806.28651h-690.347c-1,0-1.812-.468-1.812-1.045s.812-1.04505,1.812-1.04505H945.17447c1,0,1.812.468,1.812,1.045S946.17252,806.28651,945.17252,806.28651Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ac055b4e-9afd-48c4-86db-12c8e2993e8d",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b77ebe88-e0c7-4a9a-a2fb-b51dce897c46-649",
    "data-name": "Path 438",
    d: "M282.08554,765.52248a19.47406,19.47406,0,0,0,18.806-3.313c6.587-5.528,8.652-14.637,10.332-23.07l4.97-24.945-10.405,7.165c-7.483,5.152-15.134,10.47-20.316,17.933s-7.443,17.651-3.28,25.727",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8a7bc76-ff28-4167-bc9c-ebff63445848-650",
    "data-name": "Path 439",
    d: "M283.69254,797.45852c-1.31-9.542-2.657-19.206-1.738-28.85.816-8.565,3.429-16.93,8.749-23.789a39.57353,39.57353,0,0,1,10.153-9.2c1.015-.641,1.95.968.939,1.606a37.622,37.622,0,0,0-14.885,17.955c-3.24,8.241-3.76,17.224-3.2,25.978.338,5.294,1.053,10.553,1.774,15.806a.964.964,0,0,1-.65,1.144.936.936,0,0,1-1.144-.65Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "abfc2b94-a38f-4778-bd11-bd0282c86570-651",
    "data-name": "Path 442",
    d: "M293.11954,782.1495a14.336,14.336,0,0,0,12.491,6.447c6.323-.3,11.595-4.713,16.34-8.9l14.036-12.392-9.289-.444c-6.68-.32-13.533-.618-19.9,1.442s-12.231,7.018-13.394,13.6",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba99c695-899d-4604-b38e-601ed41861fa-652",
    "data-name": "Path 443",
    d: "M279.99051,802.94448c6.3-11.156,13.618-23.555,26.685-27.518a29.77893,29.77893,0,0,1,11.224-1.159c1.192.1.894,1.94-.3,1.837a27.66479,27.66479,0,0,0-17.912,4.739c-5.051,3.438-8.983,8.217-12.311,13.286-2.039,3.1-3.865,6.341-5.691,9.573C281.10352,804.73452,279.4035,803.98946,279.99051,802.94448Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#f2f2f2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "bf60e786-3805-43a5-8cdd-bbea060079bf",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "a323e3dd-8f2c-40f7-a0c1-7a235f78e8b7",
    "data-name": "Ellipse 5",
    cx: 245.91502,
    cy: 370.985,
    r: 15.986,
    fill: "#29a99a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b21d221e-9b86-4bff-9dca-a61a27263db1-653",
    "data-name": "Path 40-3",
    d: "M491.27554,461.71247c-.184,0-.333,1.193-.333,2.664s.149,2.665.333,2.665h15.719c.184.024.336-1.149.339-2.62a5.94306,5.94306,0,0,0-.328-2.708h-15.73Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b51141dd-8175-4f5a-b697-41b89601b37f",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "e363222e-d569-47a6-8bf5-edbaac636a07",
    "data-name": "Ellipse 5-2",
    cx: 245.91502,
    cy: 456.278,
    r: 15.986,
    fill: "#29a99a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf4b9d9b-b2cd-48cd-bc0b-2e6b007ef33d-654",
    "data-name": "Path 40-4",
    d: "M491.27554,547.00547c-.184,0-.333,1.193-.333,2.664s.149,2.665.333,2.665h15.719c.184.024.336-1.149.339-2.62a5.94306,5.94306,0,0,0-.328-2.708h-15.73Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "b35aa588-fd9e-4429-8570-fee6b5da93cc",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "b896a996-d737-41ee-9642-d5eaf8a9fd6b",
    "data-name": "Ellipse 5-3",
    cx: 245.91502,
    cy: 541.53599,
    r: 15.986,
    fill: "#29a99a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f0c90521-3626-484d-9767-39f7327e6a31-655",
    "data-name": "Path 40-5",
    d: "M491.27554,632.26346c-.184,0-.333,1.193-.333,2.664s.149,2.665.333,2.665h15.719c.184.024.336-1.149.339-2.62a5.9431,5.9431,0,0,0-.328-2.708h-15.73Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M625.19989,350.38193a4.48656,4.48656,0,0,1-4.01245-2.4497,52.87438,52.87438,0,0,0-31.37232-26.41114,59.99908,59.99908,0,0,0-8.408-1.9038l-.57959-.08789L610.74725,225.983l.50586.01758c58.12769,15.79492,91.385,62.38134,100.19336,76.2832a4.49382,4.49382,0,0,1-1.79663,6.42334L627.21918,349.9044A4.50685,4.50685,0,0,1,625.19989,350.38193Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "e0f3bbc9-2b9f-408e-80ac-e1d5d48fdbc4-656",
    "data-name": "Path 2881",
    d: "M804.63654,549.70647a9.27592,9.27592,0,0,1,12.711-6.383l22.283-24.293,4.164,16.616-21.8,20.521a9.326,9.326,0,0,1-17.359-6.462Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#feb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "b7278a0b-1b02-42c5-a26a-5568eba21726-657",
    "data-name": "Path 2882",
    d: "M852.49454,792.04449h-13.613l-6.478-52.517h20.1Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#feb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "ae5e3f59-c07c-4936-a848-b4ed4a22f493-658",
    "data-name": "Path 2883",
    d: "M855.96756,787.5985h-26.815a17.089,17.089,0,0,0-17.088,17.087v.556h43.9Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "e2dcac65-80ca-45a3-9c58-68329f82aa19-659",
    "data-name": "Path 2884",
    d: "M930.68353,778.55646l-12.729,4.832-24.693-46.8,18.787-7.13Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#feb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "e33efd2e-5dad-4e18-8ce5-ea4b13e613d2-660",
    "data-name": "Path 2885",
    d: "M932.35455,773.16747l-25.069,9.515h0a17.089,17.089,0,0,0-9.911,22.039l.2.519,41.045-15.578Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "aea1be6b-88fd-4404-a4b2-fdb70dea932e-661",
    "data-name": "Path 2886",
    d: "M885.86453,617.36046l11.283,60.71405s30.625,85.428,28.476,87.577-31.7,9.671-30.088,4.836-35.461-77.369-35.461-77.369Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "a45d4c0e-5c31-49a4-b00c-14ea50dd8cbe-662",
    "data-name": "Path 2887",
    d: "M840.10855,507.03047s-22.777,29.774-19.792,31.4,14.547,10.236,14.547,10.236l11.764-32.284Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e4e4e4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "ababf4ae-7dbc-4717-bb50-ecd0b5fac405-663",
    "data-name": "Path 2888",
    d: "M833.74753,537.0825s-3.761,27.939-2.149,33.849.537,173.543-.537,176.229-4.3,11.82-2.686,16.118,23.64,15.044,26.864,11.283,26.866-140.768,26.866-140.768,33.312-82.742,25.79-90.8S833.74753,537.0825,833.74753,537.0825Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "a4a0a325-f198-46ef-8204-e1264a7da486",
    "data-name": "Ellipse 542",
    cx: 629.07161,
    cy: 237.48247,
    r: 26.32701,
    fill: "#feb8b8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "f1bcc5ff-8c37-42ba-ac71-fb7b653723a6-664",
    "data-name": "Path 2890",
    d: "M854.57553,390.69649a18.66405,18.66405,0,0,1,6-11.04l4.8-14.675h28.209l7.861,12.335c8.5,3.661,14.8,9.467,15.039,16.311,1.3,4.545-4.3,148.828-5.91,154.2-.473,1.564-6.9,2.4-15.936,2.772-8.285.338-18.756.29-28.809.059-16.645-.387-32.162-1.279-34.773-1.757C825.15152,547.82848,853.99054,394.08647,854.57553,390.69649Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e4e4e4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "f2ae932d-f3ee-421e-b804-f39bdd3d1485-665",
    "data-name": "Path 2891",
    d: "M879.51553,582.02647a9.276,9.276,0,0,0,1.826-14.106l15.569-29.056-17.059,1.558-12.168,27.352a9.326,9.326,0,0,0,11.833,14.251Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#feb8b8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "a13bc27c-3d22-450d-9b6a-4857ac9e22b6-666",
    "data-name": "Path 2893",
    d: "M882.10355,374.82347s-24.715,10.208-15.581,36,19.342,56.415,19.342,56.415-12.895,69.31-12.895,72-8.059,17.193-4.836,19.88,24.715,8.059,25.252,5.373a181.71945,181.71945,0,0,1,5.91-18.268c1.075-2.149,26.327-69.31,23.1-75.22-2.372-4.349-4.454-44.2-5.388-64.939a34.107,34.107,0,0,0-17.781-28.715C894.22256,374.68749,888.39056,373.25148,882.10355,374.82347Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#e4e4e4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "a3aad1c3-1778-4515-92de-8de9e018032c-667",
    "data-name": "Path 2800",
    d: "M892.21851,342.96248c-2-.922-4.317-1.113-6.479-1.686-7.734-2.052-12.916-9.689-11.261-16.6a7.47905,7.47905,0,0,0,.406-2.736c-.289-2.047-2.687-3.368-4.986-3.837s-4.746-.4-6.943-1.155a9.39,9.39,0,0,1-6.136-7.366,13.67394,13.67394,0,0,1,2.327-9.171l.831,2.088a7.77124,7.77124,0,0,0,2.714-3.545,5.5,5.5,0,0,1,4.26,2.992c1.333.687,1.525-2.133,3-2.549a2.945,2.945,0,0,1,1.838.4c2.967,1.209,6.414.175,9.6-.495a41.22185,41.22185,0,0,1,16.771-.017c3.663.763,7.29,2.093,9.912,4.455a20.35,20.35,0,0,1,4.636,6.96c2.812,6.182,4.669,12.871,3.741,19.473a26.05108,26.05108,0,0,1-7.436,14.6c-2.123,2.137-9.05,9.591-12.848,8.321C891.38751,351.49449,897.84155,345.5595,892.21851,342.96248Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.97861,
    cy: 266.45946,
    r: 8,
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M521.30463,350.26524a4.492,4.492,0,0,1-2.1001-.52442l-81.95288-43.23437a4.5,4.5,0,0,1-1.74121-6.32471,181.66635,181.66635,0,0,1,40.991-45.9751c28.30152-22.43066,60.4939-33.68408,95.678-33.49512a151.88378,151.88378,0,0,1,39.064,5.28858l.50464.13672-29.927,93.541-.42114-.06347a66.68158,66.68158,0,0,0-8.13867-.72168c-30.45068-.85938-43.64649,19.876-47.90772,28.82959a4.41453,4.41453,0,0,1-2.62011,2.31005A4.52734,4.52734,0,0,1,521.30463,350.26524Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#29a99a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M611.122,226.483l-21.15967,94.56a60.38421,60.38421,0,0,0-8.48-1.92l29.62988-92.64Z",
    transform: "translate(-253.01352 -93.71349)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadisjsjsjs);
export default __webpack_public_path__ + "static/media/loadisjsjsjs.06b38ff51bd63fe32003e1876a608b66.svg";
export { ForwardRef as ReactComponent };